"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Emitter =
/** @class */
function () {
  function Emitter(all) {
    this.all = all || Object.create(null);
  }
  /**
   * Register an event handler for the given type.
   * @param type Type of event to listen for.
   * @param handler Function to call in response to given event.
   */


  Emitter.prototype.on = function (type, handler) {
    (this.all[type] || (this.all[type] = [])).push(handler);
  };
  /**
   * Remove an event handler for the given type.
   * @param type Type of event to unregister `handler` from.
   * @param handler Handler function to remove.
   */


  Emitter.prototype.off = function (type, handler) {
    if (this.all[type]) {
      this.all[type].splice(this.all[type].indexOf(handler) >>> 0, 1);
    }
  };
  /**
   * Invoke all handlers for the given type.
   * @param type The event type to invoke.
   * @param evt Any value (object is recommended and powerful),
   * passed to each handler.
   * @param changed Any changed values if the event encompasses more.
   */


  Emitter.prototype.emit = function (type, evt, changed) {
    (this.all[type] || []).slice().forEach(function (handler) {
      return changed ? handler(evt, changed) : handler(evt);
    });
  };

  return Emitter;
}();

var _default = Emitter;
exports.default = _default;